
import { createBrowserRouter } from 'react-router-dom'
import App from '../App'
import Home from '../pages/Home'
import Login from '../pages/Login'
import ForgotPassowrd from '../pages/ForgotPassowrd'
import SignUp from '../pages/SignUp'
import AdminPanel from '../pages/AdminPanel'
import AllUsers from '../pages/AllUsers'
import AllProducts from '../pages/AllProducts'
import CategoryProduct from '../pages/CategoryProduct'
import ProductDetails from '../pages/ProductDetails'
import Cart from '../pages/Cart'
import SearchProduct from '../pages/SearchProduct'
import Checkout from '../pages/Checkout'
import OrderSuccess from '../pages/OrderSuccess'
import Account from '../pages/Account'
import MyOrders from '../pages/MyOrders'
import ProfilePage from '../pages/ProfilePage'
import AdminDashboard from '../pages/AdminDashboard'
import AdminOrders from '../pages/AdminOrders'
import OrderDetails from '../pages/OrderDetails'   // 🔥 added
import AddressPage from '../pages/AddressPage'
import ProtectedRoute from '../components/ProtectedRoutes'
import Policy from '../pages/Policy'
import ReturnPolicy from '../pages/ReturnPolicy'
import TermsOfService from '../pages/TermsOfService'
import ContactPage from '../pages/ContactPage'
import HelpCenter from '../pages/HelpCenter'

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { path: "", element: <Home /> },
      { path: "login", element: <Login /> },
      { path: "forgot-password", element: <ForgotPassowrd /> },
      { path: "sign-up", element: <SignUp /> },
      { path: "checkout", element: <Checkout /> },
      { path: "order-success", element: <OrderSuccess /> },
      { path: "product-category", element: <CategoryProduct /> },
      { path: "product/:id", element: <ProductDetails /> },
      { path: "cart", element: <Cart /> },
      { path: "search", element: <SearchProduct /> },

      // 🔥 Order Details Route
      {
        path: "order/:id",
        element: <OrderDetails />
      },
      {path: "privacy-policy",element:<Policy/> },
      {path: "return-policy", element: <ReturnPolicy/> },
      {path: "terms", element: <TermsOfService/> },
      { path: "contact", element: <ContactPage/> },

      {
        path: "admin-panel",
        element: <AdminPanel />,
        children: [
          { path: "dashboard", element: <AdminDashboard /> },
          { path: "all-users", element: <AllUsers /> },
          { path: "all-products", element: <AllProducts /> },
          { path: "orders", element: <AdminOrders /> }
        ]
      },

      {
        path: "account",
        element:
        
        (<ProtectedRoute><Account /></ProtectedRoute>),
        children: [
          { path: "profile", element: <ProfilePage /> },
          { path: "orders", element: <MyOrders /> },
          {path : "address", element: <AddressPage/>},
          {path : "help", element: <HelpCenter/>},
        ]
      }
    ]
  }
])

export default router